module.exports = __webpack_public_path__ + "static/media/folder.6a0879ec.svg";